import React from 'react';

import Card from '@/components/atoms/card';
import LinkButton from '@/components/atoms/linkButton';
import { Text } from '@/components/atoms/text';

import { CarouselBlockCardProps } from '@/features/carouselBlock/types';

import IconChevronRight from '~/svg/IconChevronRight.svg';

export const CarouselItem = (item: CarouselBlockCardProps) => {
  const { cardUrl, cardTitle, actionLabel, renderImage } = item;

  const Content = () => (
    <Card
      classNames={{
        root: 'h-[208px] max-w-[240px] flex-col p-6 pb-4 group dark:border-neutral-dark-N80 dark:bg-transparent dark:hover:bg-neutral-dark-N94 rounded-3xl border-neutral-N10 hover:bg-neutral-N02 hover:border-neutral-N10 shadow-none',
      }}
      hasHoverEffect={!!cardUrl}
    >
      {renderImage({ classNames: { image: 'w-12 h-12' } })}
      {cardTitle && (
        <Text variant='subtitle-l' classNames={{ wrapper: 'mt-4 block' }}>
          {cardTitle}
        </Text>
      )}
      {actionLabel && (
        <Text
          color='primary-P99'
          variant='body-l'
          classNames={{ wrapper: 'absolute bottom-4 flex items-center gap-1' }}
        >
          {actionLabel}
          <span className='transition duration-300 ease-in-out group-hover:translate-x-2'>
            <IconChevronRight />
          </span>
        </Text>
      )}
    </Card>
  );

  if (cardUrl) {
    return (
      <LinkButton href={cardUrl} noStyles>
        <Content />
      </LinkButton>
    );
  } else {
    return <Content />;
  }
};
